"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropDown = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _FormFieldsBox = _interopRequireDefault(require("../FormFieldsBox"));

var _KeyboardArrowDown = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowDown"));

var _Optimizers = require("../../utils/Optimizers");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * singleChoice component for whitelabel registration funnel
 * @param {*} param0
 */
var DropDownComponent = function DropDownComponent(_ref) {
  var config = _ref.config,
      context = _ref.context;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue;

  var handleChange = function handleChange(event) {
    setValue(config.valueName, config.valueType === 'Number' ? Number(event.target.value) : event.target.value);
  };
  /**
   * render select options
   */


  var options = function options() {
    var options = [];
    options.push( /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
      value: "",
      children: t(config.translations.selectPlaceholderText)
    }, "firstOpt"));

    if (config.options) {
      config.options.forEach(function (option) {
        options.push( /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: option.value,
          children: option.text
        }, "option ".concat(option.text)));
      });
    }

    if (config.numberRange) {
      if (config.numberRange.order === 'ascending') {
        for (var i = config.numberRange.minimum; i < config.numberRange.maximum; i++) {
          options.push( /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            value: i,
            children: i
          }, i + 'opt'));
        }
      } else {
        for (var _i = config.numberRange.maximum; _i > config.numberRange.minimum; _i--) {
          options.push( /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            value: _i,
            children: _i
          }, _i + 'opt'));
        }
      }
    }

    return options;
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _styleModule.default.dropDown,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
      headline: t(config.translations.text),
      text: config.translations.hint ? t(config.translations.hint) : ''
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _styleModule.default.dropDownBox,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormFieldsBox.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("select", {
          className: _styleModule.default.selector,
          value: context[config.valueName].value,
          onChange: handleChange,
          inputProps: {
            name: config.valueName,
            id: "".concat(config.valueName, "-native-helper")
          },
          IconComponent: _KeyboardArrowDown.default,
          children: options()
        })
      })
    })]
  });
};

var DropDownWrapper = (0, _Optimizers.memoizeComponentByValue)(DropDownComponent);

var DropDown = function DropDown(_ref2) {
  var config = _ref2.config;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DropDownWrapper, {
    config: config,
    context: context
  });
};

exports.DropDown = DropDown;